import { render, staticRenderFns } from "./AbonoDetalle.vue?vue&type=template&id=a61b4bbc"
import script from "./AbonoDetalle.vue?vue&type=script&lang=js"
export * from "./AbonoDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports